import React from 'react';
import {
    Col,
    Form,
    Input,
    Row,
} from 'antd';
import FormStepButton from '../FormStepButton';
import FormStepTitle from '../FormStepTitle';
import {
    validateEmail,
    validateContactNumber,
    validateConfirmEmail,
    validateFullName,
} from '../../../constants/formValidation';


const FormStepCustomer  = props => {
    const { form, formItemLayout, submitStep  } = props;
    const { getFieldDecorator } = form;
    const emailAddress = form.getFieldValue('emailAddress');
    const fullName = form.getFieldValue('fullName');

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (err) return;

            submitStep({
                fullName: values.fullName,
                emailAddress: values.emailAddress,
                contactNumber: values.contactNumber,
            });
        });
    };

    return (
        <Row gutter={40}>
            <Col span={24}>
                <Form onSubmit={handleSubmit} {...formItemLayout}>
                    <FormStepTitle label="Add your details" />
                    <Form.Item label="Full Name">
                        {
                            getFieldDecorator('fullName', validateFullName(fullName))(
                                <Input />
                            )
                        }
                    </Form.Item>
                    <Form.Item label="Email Address">
                        {
                            getFieldDecorator('emailAddress', validateEmail())(
                                <Input />
                            )
                        }
                    </Form.Item>
                    <Form.Item label="Confirm Email Address">
                        {
                            getFieldDecorator('confirmEmailAddress', validateConfirmEmail(emailAddress))(
                                <Input />
                            )
                        }
                    </Form.Item>
                    <Form.Item label="Contact Number">
                        {
                            getFieldDecorator('contactNumber', validateContactNumber())(
                                <Input />
                            )
                        }
                    </Form.Item>
                    <FormStepButton />
                </Form>
            </Col>
        </Row>
    );
};

export default Form.create({ name: 'customer' })(FormStepCustomer);
